<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { getFirstSourceStore, getTemplatedElementDataFromSource, } from "../../../utilities";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { resolveUrl } from "../../../../../js/url";
import { YinzCamLoyaltyServer, YinzCamLoyaltyServerToken } from 'yinzcam-loyalty';
import ResultCard from "../common/ResultCard.svelte";
import { Popup } from "framework7-svelte";
import _ from "lodash";
export let element;
export let sources;
export let sourceStore;
const loyaltyServer = getToken(ROOT, YinzCamLoyaltyServerToken);
$: {
    sourceStore = getFirstSourceStore($sources);
}
;
$: data = (sourceStore && $sourceStore) ? $sourceStore : null;
$: extraData = (data === null || data === void 0 ? void 0 : data.ExtraData) ? JSON.parse(data.ExtraData) : {};
$: currencyImage = String(((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.currencyImage) || "");
$: fontFace = String((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.fontFace) || "";
$: currencyColor = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.currencyTextColor) || "";
$: currencyFontSize = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.currencyFontSize) || "14px";
$: fontSize = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.textFontSize) || "16px";
$: textColor = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.textColor) || '#fff';
$: descriptionFontSize = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.descriptionFontSize) || "14px";
$: descriptionColor = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.descriptionColor) || "#fff";
$: buttonText = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.buttonText) || "";
$: buttonBackgroundColor = ((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.buttonBackgroundColor) || "";
$: buttonFontSize = (_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.buttonFontSize;
$: buttonFontColor = (_m = element === null || element === void 0 ? void 0 : element.data) === null || _m === void 0 ? void 0 : _m.buttonFontColor;
$: buttonWidth = ((_o = element === null || element === void 0 ? void 0 : element.data) === null || _o === void 0 ? void 0 : _o.buttonWidth) || "150px";
$: buttonBorderStyle = ((_p = element === null || element === void 0 ? void 0 : element.data) === null || _p === void 0 ? void 0 : _p.buttonBorderStyle) || "";
$: buttonBorderColor = ((_q = element === null || element === void 0 ? void 0 : element.data) === null || _q === void 0 ? void 0 : _q.buttonBorderColor) || "";
$: buttonBorderRadius = ((_r = element.data) === null || _r === void 0 ? void 0 : _r.buttonBorderRadius) || "4px";
$: backgroundImage = String(((_s = element === null || element === void 0 ? void 0 : element.data) === null || _s === void 0 ? void 0 : _s.backgroundImage) || "");
$: imageWrapperStyle = String(((_t = element === null || element === void 0 ? void 0 : element.data) === null || _t === void 0 ? void 0 : _t.imageWrapperStyle) || "width: 100%;");
$: imageWrapperImgStyle = String(((_u = element === null || element === void 0 ? void 0 : element.data) === null || _u === void 0 ? void 0 : _u.imageWrapperImgStyle) || "width: 100%;");
$: popupBackgroundColor = String(((_v = element === null || element === void 0 ? void 0 : element.data) === null || _v === void 0 ? void 0 : _v.popupBackgroundColor) || "");
$: popupTitleColor = String(((_w = element === null || element === void 0 ? void 0 : element.data) === null || _w === void 0 ? void 0 : _w.popupTitleColor) || "");
$: popupDescriptionColor = String(((_x = element === null || element === void 0 ? void 0 : element.data) === null || _x === void 0 ? void 0 : _x.popupDescriptionColor) || "");
$: successHeaderImage = String(((_y = element === null || element === void 0 ? void 0 : element.data) === null || _y === void 0 ? void 0 : _y.successHeaderImage) || "");
$: successTitle = String(((_z = element === null || element === void 0 ? void 0 : element.data) === null || _z === void 0 ? void 0 : _z.successTitle) || "");
$: successButtonBackground = String(((_0 = element === null || element === void 0 ? void 0 : element.data) === null || _0 === void 0 ? void 0 : _0.successButtonBackground) || "");
$: successButtonColor = String(((_1 = element === null || element === void 0 ? void 0 : element.data) === null || _1 === void 0 ? void 0 : _1.successButtonColor) || "");
$: successButtonText = String(((_2 = element === null || element === void 0 ? void 0 : element.data) === null || _2 === void 0 ? void 0 : _2.successButtonText) || "");
$: failHeaderImage = String(((_3 = element === null || element === void 0 ? void 0 : element.data) === null || _3 === void 0 ? void 0 : _3.failHeaderImage) || "");
$: failTitle = String(((_4 = element === null || element === void 0 ? void 0 : element.data) === null || _4 === void 0 ? void 0 : _4.failTitle) || "");
$: failButtonBackground = String(((_5 = element === null || element === void 0 ? void 0 : element.data) === null || _5 === void 0 ? void 0 : _5.failButtonBackground) || "");
$: failButtonColor = String(((_6 = element === null || element === void 0 ? void 0 : element.data) === null || _6 === void 0 ? void 0 : _6.failButtonColor) || "");
$: failButtonText = String(((_7 = element === null || element === void 0 ? void 0 : element.data) === null || _7 === void 0 ? void 0 : _7.failButtonText) || "");
$: successUrl = resolveUrl(String(((_8 = element === null || element === void 0 ? void 0 : element.data) === null || _8 === void 0 ? void 0 : _8.successUrl) || ""));
$: failUrl = resolveUrl(String(((_9 = element === null || element === void 0 ? void 0 : element.data) === null || _9 === void 0 ? void 0 : _9.failUrl) || ""));
$: text = (data === null || data === void 0 ? void 0 : data.Name) || "";
$: currency_amount = (data === null || data === void 0 ? void 0 : data.PointValue) || 0;
$: image = extraData === null || extraData === void 0 ? void 0 : extraData.ImageUrl;
$: description = (data === null || data === void 0 ? void 0 : data.UserInstructions) || "";
let popupResult = null;
let popupMessage = "";
function redeemReward() {
    return __awaiter(this, void 0, void 0, function* () {
        console.log('redeemReward', data === null || data === void 0 ? void 0 : data.RewardID);
        try {
            const redeemResult = yield loyaltyServer.postHubRewardRedeem(data === null || data === void 0 ? void 0 : data.RewardID);
            console.log('HubRewardRedeem RESULT', redeemResult);
            if (!(redeemResult === null || redeemResult === void 0 ? void 0 : redeemResult.Redeemed)) {
                popupMessage = (redeemResult === null || redeemResult === void 0 ? void 0 : redeemResult.Message) ? _.replace(redeemResult.Message, 'You can at most redeem 0 of this reward', 'You can only redeem this reward once.') : "Redemption failed, please try again.";
                popupResult = false;
            }
            else {
                popupMessage = (redeemResult === null || redeemResult === void 0 ? void 0 : redeemResult.Message) ? redeemResult.Message : "You have successfully redeemed this reward.";
                popupResult = true;
            }
        }
        catch (e) {
            popupMessage = "Redemption failed, please try again.";
            popupResult = false;
        }
    });
}
</script>
  
  <CardBase {element}>
    <div class="reward-item-detail-wrapper">
      <Popup
      opened={popupResult === true}
      onPopupClosed={() => (popupResult = null)}
      swipeToClose={false}
      class="result-popup"
      >
        <ResultCard
          backgroundColor={popupBackgroundColor}
          {fontFace}
          headerImage={successHeaderImage}
          titleColor={popupTitleColor}
          descriptionColor={popupDescriptionColor}
          title={successTitle}
          description={popupMessage}
          buttonBackground={successButtonBackground}
          {successButtonColor}
          {successButtonText}
          backgroundImage={backgroundImage}
          imageWrapperStyle={imageWrapperStyle}
          imageWrapperImgStyle={imageWrapperImgStyle}
          buttonBorderRadius={buttonBorderRadius}
          onButtonClick={() => { popupResult = null; successUrl.func(); } }
        />
      </Popup>
      <Popup
        opened={popupResult === false}
        onPopupClosed={() => (popupResult = null)}
        swipeToClose={false}
        class="result-popup"
      >
        <ResultCard
          backgroundColor={popupBackgroundColor}
          {fontFace}
          headerImage={failHeaderImage}
          titleColor={popupTitleColor}
          descriptionColor={popupDescriptionColor}
          title={failTitle}
          description={popupMessage}
          buttonBackground={failButtonBackground}
          successButtonColor={failButtonColor}
          successButtonText={failButtonText}
          backgroundImage={backgroundImage}
          imageWrapperStyle={imageWrapperStyle}
          imageWrapperImgStyle={imageWrapperImgStyle}
          buttonBorderRadius={buttonBorderRadius}
          onButtonClick={() => { popupResult = null; failUrl.func(); }}
        />
      </Popup>
      {#if image}
      <img class="hero-img" src={image} />
      {/if}
      <div class="text-layout" style={`font-family: ${fontFace};`}>
        <div class="currency-layout">
          <img src={currencyImage} alt="currency-img" class="currency-img" />
          <span class="" style={`font-size: ${currencyFontSize}; color: ${currencyColor}; margin-top: 4px; margin-bottom: -4px;`}>{currency_amount}</span>
        </div>
        <span class="detail-title" style={`font-size: ${fontSize}; color: ${textColor};`}>{text}</span>
        <p class="detail-description" style={`font-size: ${descriptionFontSize}; color: ${descriptionColor}`}>{description}</p>
        <button class="detail-button" style={`font-family: ${fontFace}; background: ${buttonBackgroundColor}; font-size: ${buttonFontSize}; color: ${buttonFontColor}; width: ${buttonWidth}; border-style:${buttonBorderStyle}; border-color:${buttonBorderColor}; border-radius:${buttonBorderRadius};`} on:click={() => redeemReward()} >{buttonText}</button>
      </div>
    </div>
  </CardBase>
  
  <style type="text/scss">*,
*:before,
*:after {
  box-sizing: border-box;
}

.reward-item-detail-wrapper {
  display: flex;
  flex-direction: column;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
}

.hero-img {
  width: 100%;
  height: auto;
}

.text-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  padding: 8px;
}

.detail-description {
  text-align: center;
}

.currency-layout {
  margin-top: auto;
  display: flex;
  gap: 8px;
  align-items: center;
}

.currency-img {
  width: 32px;
  height: 32px;
}

.detail-button {
  width: 150px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}</style>
  